module.exports = __webpack_public_path__ + "img/m_key.a2f7cf2b.png";